module.exports = __webpack_public_path__ + "img/1-itol-login.748663e3.png";